<template>
    <transition name="modal">
        <!-- Modal -->
        <div class="modal-mask modal-lg">
            <div class="modal-wrapper box">

                <columns-picker-modal v-if="showColumnPicker"
                                      v-bind:available-columns="availableColumns"
                                      v-on:close="showColumnPicker = false"></columns-picker-modal> 

                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            <button type="button" class="close" @click="$emit('close')">
                                <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                            </button>
                            <div>
                                <a class="fa fa-2x fa-columns pull-left" v-on:click.prevent="showColumnPicker = !showColumnPicker"></a>
                                <h3 class="pull-left">{{componentModel.name}}</h3>
                            </div>
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">                           
                            <div class="row" v-bind:style="{height: tableHeight + 'px'}">
                                <div class="col-xs-12 chart-wrapper" v-if="loading">
                                    <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                                </div>
                                <div class="col-xs-12 chart-wrapper">
                                    <div class="endless-table-container"> 
                                        <endless-table v-bind:storage-key="componentModel.id + '-leads-q'"
                                                       v-bind:picked-columns="pickedColumns"
                                                       v-bind:field-list="query.fields"
                                                       v-bind:order-by="query.order_by"
                                                       v-bind:order-asc="query.asc"
                                                       v-bind:lead-list="leads"
                                                       v-on:fetchLeads="fetchLeads"></endless-table>
                                    </div>
                                </div>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
import Vue from 'vue'
import EndlessTable from 'components/elements/EndlessTable';
import ColumnsPickerModal from 'components/modals/ColumnsPickerModal';


export default {
  components: { 
    EndlessTable,
    ColumnsPickerModal
  },

  props: {
    component: {
      type: Object,
      default () {
        return {
          name: '',
          chart: null,
          domains: [],
          images: []
        };
      }
    },
  },

  data () {
    return {
      loading: false,

      query: {
        q: null,
        rules: {
          clause: null
        }
      },

      availableColumns: [],
      fieldsOptions: [
        {
          label: 'Meta',
          fields: [
            { name: 'id', val: 'id' },
            { name: 'timestamp', val: 'timestamp' },
            { name: 'status', val: 'status' },
            { name: 'score', val: 'score' }
          ],
        },
      ],

      pagination: {
        current_page: 1, // required
      },
      leads: [],
      
      placeholder: 'Columns',
      showColumnPicker: false,
    };
  },

  computed: {
    tableHeight () {
      return $(window).height() - 300;
    },
    pickedColumns () {
      return this.availableColumns.filter(function (e) { return e.picked; });
    }
  },

  watch: {
    pickedColumns () {
      var self = this;
      self.query.fields = self.pickedColumns.map(function (e) {
        return (e.path != "" ? e.path + "." + e.slug : e.slug);
      });
      self.fetchLeads();
    }
  },

  created () {
    // Init componentModel
    this.componentModel = this.component;
    this.query.component = this.component;

    this.fetchFields();
  },

  methods: {
      fetchFields () {
      var self = this;
      var labelsChoices = {
        M: { label: 'Meta', path: '', values: [] },
        S: { label: 'Score', path: '', values: [] },
        L: { label: 'Lead', path: 'fields', values: [] },
        C: { label: 'CRM', path: 'crm_fields', values: [] },
      };

      API.fields.getList().then(function (response) {
        var results = response.data;

        if (!self.query.fields) {
          self.query.fields = [];
        }
        /* Defaults for availableColumns */
        var columns = [
          {type: 'M',
           path: "",
           name: 'Timestamp',
           slug: 'timestamp',
           picked: self.query.fields.indexOf('timestamp') >= 0
          },
          {type: 'S',
           path: "",
           name: 'Score',
           slug: 'score',
           picked: self.query.fields.indexOf('score') >= 0
          },          
        ];
        for (var index in results) {
          var field = results[index];
          columns.push({type: field.field_type,
                        path: labelsChoices[field.field_type].path,
                        name: field.name,
                        slug: field.slug,
                        picked: self.query.fields.indexOf(labelsChoices[field.field_type].path + '.' + field.slug) >= 0
                       });
          var path = labelsChoices[field.field_type].path;
          labelsChoices[field.field_type].values.push({
            name: field.name,
            val: (path != '' ? path + '.' + field.slug : field.slug),
          })
        }
        // We need to sort the fields based on self.query.fields
        var headColumns = [];
        var tailColumns = [];
        self.query.fields.forEach(function (item) {
          var i = API.fields.findFieldByPath(columns, item);
          if (i >= 0) {
            headColumns.push(columns.splice(i, 1)[0]);
          }
        });

        self.availableColumns = headColumns.concat(columns);

        for (var index in labelsChoices) {
          var choice = labelsChoices[index];
          self.fieldsOptions.push({
            label: choice.label, fields: choice.values
          });
        }

        // Fetching initial rows
        self.fetchLeads();
      });
    },

    fetchLeads: _.debounce(function (params, nextPage, success) {
      if (nextPage) {
        this.pagination.current_page += 1;
      }
      if (this.pagination.current_page && this.pagination.current_page > 1) {
        this.query.page = this.pagination.current_page;
      }
      if (params) {
        if (params.order_by !== undefined) {
          this.query.order_by = params.order_by;
        }
        if (params.asc !== undefined) {
          this.query.asc = params.asc;
        }
      }
      this.query.page_size = 50;

      var queryRequest = Vue.leadscorz.deep_clone(this.query);
      queryRequest.fields = JSON.stringify(queryRequest.fields);
      queryRequest.c = API.rules.serializeRules(this.query.c);

      var self = this;
      self.isLoading = true;

      API.leads.getList(queryRequest)
        .then(function (response) {
          if (success && typeof success === 'function') {
            success(response)
          } else {
            self.leads = response.data.leads;
          }

          self.isLoading = false;
        });

    }, 50),
  }
};
</script>


<style>

.leads-modal-control-btn {
    display: inline-block !important;
    position: absolute;
    left: 0;
    top: 14px;
    z-index: 2;
}
</style>



// WEBPACK FOOTER //
// LeadsModal.vue?41bea61c